import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body p-0 d-flex justify-content-between flex-column" }
const _hoisted_2 = {
  class: "d-flex flex-stack flex-grow-1",
  style: {"padding":"24px 27px 0px 27px"}
}
const _hoisted_3 = { class: "me-2 flex-grow-1" }
const _hoisted_4 = { class: "fs-3 mb-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"grey"} }, "฿ ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "fw-boldest" }, "69,700 ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  style: {"padding":"5px"},
  class: "btn btn-sm btn-light-success fw-boldest"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-up" }),
  /*#__PURE__*/_createTextVNode("4.2% ")
], -1)
const _hoisted_8 = {
  class: "pt-1",
  style: {"margin-bottom":"-52.72px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("dashboard")), 1),
            _hoisted_7
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("todaysales")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_apexchart, {
          type: "bar",
          height: "173",
          options: _ctx.chartOptions,
          series: _ctx.series1
        }, null, 8, ["options", "series"])
      ])
    ])
  ], 2))
}